// @flow
import React, { Component } from 'react'
import { translations, translateFunc } from '../../shared/localize'
import HintWrapper from '../controls/HintWrapper'
import { linkColor } from '../controls/colors'
import styled from 'styled-components'
import type { StyledComponent } from 'styled-components'

const CloseLink = styled.span`
  color: ${linkColor};
  text-decoration: none;
  padding-left: 5px;
  cursor: pointer;
`
const Wrapper: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  font-size: 14px;
  white-space: nowrap;
  padding: 2px 0 2px 5px;
`

type Props = {|
  name: string,
  hint: string,
  path?: string,
  onClose?: Function
|}

const t = translateFunc(translations.targeting_sources)

export default class ListItem extends Component<Props> {
  render() {
    const { path, name, hint, onClose } = this.props

    return (
      <Wrapper>
        <HintWrapper popupRenderer={<pre>{hint}</pre>}>
          {path ? (
            <a href={path} target="_blank">
              {name}
            </a>
          ) : (
            <span>{name}</span>
          )}
        </HintWrapper>
        <HintWrapper popupText={t('remove_from_list', { name: name })}>
          <CloseLink className="t-RemoveRetargetingItem" onClick={() => onClose && onClose()}>
            [x]
          </CloseLink>
        </HintWrapper>
      </Wrapper>
    )
  }
}
